<template>
    <div class="kanban-container">
        <!-- Header Fixed -->
        <div class="kanban-header">
            <q-card flat class="header-card">
                <q-card-section class="row items-center q-py-sm">
                    <div class="col-12">
                        <span class="text-body2 text-grey-7">
                            Presupuestos por Estado
                        </span>
                    </div>
                </q-card-section>
            </q-card>
        </div>

        <!-- Kanban Content con scroll horizontal -->
        <div class="kanban-content">
            <ul class="vue-dnd-kanban">
                <!-- Columnas -->
                <DropZone
                    v-for="(column, index) in columns"
                    :key="column.id"
                    :column="column"
                    :columns="columns"
                    :column-index="index"
                />
            </ul>
        </div>

        <q-inner-loading :showing="loading">
            <q-spinner-hourglass size="50px" color="primary" />
        </q-inner-loading>
    </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useKanbanState } from '@/composables/useKanbanState'
import { useKanbanColumnsStore } from '@/stores/useKanbanColumnsStore'
import DropZone from './KanbanDropZone.vue'

// Composable del kanban
const { columns, fetchItems, loading } = useKanbanState()
const columnsStore = useKanbanColumnsStore()

// Cargar el estado de las columnas desde localStorage y los presupuestos al montar
onMounted(() => {
    columnsStore.loadState()
    fetchItems()
})
</script>

<style lang="scss" scoped>
.kanban-container {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #f5f5f5;
}

.kanban-header {
    flex-shrink: 0;
    padding: 12px 16px;
    background-color: white;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);

    .header-card {
        border-radius: 12px !important;
    }
}

.kanban-content {
    flex: 1;
    overflow: hidden;
    padding: 16px;
}

.vue-dnd-kanban {
    display: flex;
    gap: 1rem;
    margin: 0;
    padding: 0;
    list-style: none;
    overflow-x: auto;
    height: 100%;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
        Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    color: #333;
    background-color: transparent;
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;

    &::-webkit-scrollbar {
        height: 6px;
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 9999px;
    }
}

.kanban-column-item {
    flex-shrink: 0;
}
</style>

